import * as React from "react";
import { IBaseInputFieldProperty, IPropertyEditorProps, IUIFieldProps, registerUIField } from "../../common";
import { Input, Label } from "uxp/components";
import { hasValue, parseValue } from "../../../../util";
import { Property, PropertyContainer, PropertyGroup, PropertyGroupTitle, PropertyTitle } from "../../ui-props/common";
import { FieldProperty, FieldTitle, IFieldTitleProps } from "../../components/FieldTitle";

interface ITextFieldProperty extends IBaseInputFieldProperty {
	placeholder: string;
	textColor: string;
	backgroundColor: string;
	fontSize: string,
	textAlign: string,
	fieldLabel: IFieldTitleProps,
}

export const Field: React.FunctionComponent<IUIFieldProps<ITextFieldProperty>> = (props) => {
	let { value, onChange, placeholder, textColor, backgroundColor, fontSize, textAlign, fieldLabel } = props?.fieldProps || {};

	let styles: React.CSSProperties = {}
	if (hasValue(textColor)) styles.color = parseValue(textColor, props.contextData)
	if (hasValue(backgroundColor)) styles.backgroundColor = parseValue(backgroundColor, props.contextData)
	if (hasValue(fontSize)) styles.fontSize = fontSize
	if (hasValue(textAlign)) styles.textAlign = textAlign as any

	return (
		<div className={`ui-field ${props.mode} read-only`} >
			<FieldTitle {...props?.fieldProps?.fieldLabel || {}} />
			{props?.mode == 'preview' ?
				<Input
					value={value || ''}
					placeholder={placeholder || ''}
					onChange={onChange}
					styles={styles}
				/>
				:
				<Label> {value || ''} </Label>
			}
		</div>
	)
}

export const PropertyEditor: React.FunctionComponent<IPropertyEditorProps<ITextFieldProperty>> = (props) => {

	return <PropertyContainer>
		<PropertyGroup>
			<PropertyGroupTitle>Text Input</PropertyGroupTitle>

			<Property>
				<PropertyTitle>Value</PropertyTitle>
				<Input
					value={props.uiProps.value || ''}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { value: s }))}
					className="widget-designer-input"
				/>
			</Property>

			<Property>
				<PropertyTitle>Placeholder</PropertyTitle>
				<Input
					value={props.uiProps.placeholder || ''}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { placeholder: s }))}
					className="widget-designer-input"
				/>
			</Property>

			{/* <Property>
				<PropertyTitle>Text Color </PropertyTitle>
				<CustomColorPicker contextData={props.contextData}
					color={props.uiProps.textColor || ''}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { textColor: s }))}
				/>
			</Property>

			<Property>
				<PropertyTitle>Align</PropertyTitle>
				<TextAlignEditor
					value={props.uiProps.textAlign || 'left'}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { textAlign: s }))}
				/>
			</Property>

			<Property>
				<PropertyTitle>Background Color </PropertyTitle>
				<CustomColorPicker contextData={props.contextData}
					color={props.uiProps.backgroundColor || ''}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { backgroundColor: s }))}
				/>
			</Property> */}

		</PropertyGroup>
		<FieldProperty uiProps={props.uiProps} onChange={props.onChange} />
	</PropertyContainer>;
}

registerUIField({
	id: 'readonly',
	description: 'Read only input',
	field: Field,
	propertyEditor: PropertyEditor,
	isInputField: true,
	defaultProps: {
		placeholder: 'Enter some text',
		backgroundColor: '',
		textColor: '',
		fontSize: '12px',
		textAlign: 'left',
		fieldLabel: {
			label: 'Text Label',
		},
	},
	type: 'text'

});